export default __webpack_public_path__ + "static/media/elevenplus.362bbc4f.png";